import { ComponentChildren, h } from 'preact';
import { useStore } from 'src/hooks';
import Button from 'src/components/button';
import { EMAIL, URL } from 'src/common/constants';

interface ContactLinkProps {
    children: ComponentChildren;
    type?: 'button' | 'link';
}

const ContactLink = ({ children, type = 'link' }: ContactLinkProps) => {
    const ctx = useStore();
    const isLoggedIn = ctx.user.isLoggedIn.value;
    const url = isLoggedIn ? `mailto:${EMAIL.SUPPORT}` : URL.CAMCONTACTS_HELP_REQUEST;

    if (type === 'button') {
        return <Button href={url}>{children}</Button>;
    }

    return (
        <a data-native href={url}>
            {children}
        </a>
    );
};

export default ContactLink;
